import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const {
    fromDate,
    toDate,
    title,
    subtitles
  } = this.helpers.getFormattedReportMeta();
  return jsx("div", {
    sel: '.mp-download-wrapper-container'
  }, this.helpers.isFileDownload() ? jsx(null, null, jsx("div", {
    sel: '.header'
  }, title ? jsx("div", {
    sel: '.title'
  }, title) : null, fromDate && toDate ? jsx("div", {
    sel: '.dates'
  }, jsx("div", {
    sel: '.from-date'
  }, fromDate), jsx(SvgIconEl, {
    attrs: {
      icon: "arrow-right"
    }
  }), jsx("div", {
    sel: '.to-date'
  }, toDate)) : null, jsx("div", {
    sel: '.subtitle'
  }, subtitles.join(" \u2022 "))), jsx("slot", null), jsx("div", {
    sel: '.source'
  }, "Source:", jsx("a", {
    sel: '.mp-link',
    attrs: {
      href: this.helpers.getReportLocation()
    }
  }, "Mixpanel"))) : jsx("slot", null));
}